import { createSlice } from "@reduxjs/toolkit";

const initialMovieTag = {
    smallTag: {
        isSmallTag: false,
        isToggleBtnClicked: false
    },
    largeTag: {
        isLargeTag: true,
        isToggleBtnClicked: false
    },
    gridTag: {
        isGridTag: false,
        isToggleBtnClicked: false
    },
    imageTag: {
        isImageTag: false,
        isNavBtnClicked: false
    },
    toggleBtn: {
        isSmallTag: false,
        isLargeTag: true
    }
};

const MovieTagSlice = createSlice({
    name: "movietag",
    initialState: initialMovieTag,
    reducers: {
        toggleToSmall: (state, action) => {
            return {...state, smallTag: {...state.smallTag, isSmallTag: !state.smallTag.isSmallTag}, largeTag: {...state.largeTag, isLargeTag: !state.largeTag.isLargeTag}}
        },
        toggleToLarge: (state, action) => {
            return {...state, largeTag: {...state, isLargeTag: !state.largeTag.isLargeTag}, smallTag: {...state.smallTag, isSmallTag: !state.smallTag.isSmallTag}}
        },
        switchGrid: (state, action) => {
            return {...state, gridTag: {...state.gridTag, isGridTag: !state.gridTag.isGridTag}}
        },
        switchImage: (state, action) => {
            return {...state, imageTag: {...state.imageTag, isImageTag: !state.imageTag.isImageTag}}
        },
        clickToggleBtn: (state, action) => {
            return {...state, toggleBtn: {isSmallTag: !state.toggleBtn.isSmallTag, isLargeTag: !state.toggleBtn.isLargeTag}}
        }
   }
})

//Selector, export Selector
//export const selectToggleToSmall = state => state.movietag.toggleToSmall;
//export const selectToggleToLarge = state => state.movietag.toggleToLarge;
//export const selectSwitchGrid = state => state.movietag.switchGrid;
//export const selectSwitchImage = state => state.movietag.switchImage;
export const selectClickToggleBtn = state => state.movieTag.toggleBtn;

//Export Action Creators, Reducers from Slice
export const {clickToggleBtn} = MovieTagSlice.actions;
export default MovieTagSlice.reducer;